import { React, useState, useEffect } from "react";
import AdminDashboardLayout from "../../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../../dashboard/dashboard.styled";
import { IntroductionHeader } from "../../dashboard/Dashboard";
import { InformationsWrapper } from "../../customer/customersPage.styled";
import {
	SelectField,
	InputField,
} from "../../../components/Form/FormComponents";
import {
	Formgroup,
	ButtonGroup,
	Button,
} from "../../Products/Forms/ProductForm.styled";
import FormAccordion from "../../../components/Form/FormAccordion";
import { AiOutlineDelete } from "react-icons/ai";
import {
	getSingleAdmin,
	deleteAdmin,
	updateAdminDetails,
	getDepartments,
	getPrivileges,
} from "../utils";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import ConfirmModal from "../../../components/ConfirmModal";
import { useNavigate } from "react-router";
import saveIcon from "../../../assets/icons/Edit-Square.svg";

function SingleUser() {
	const navigate = useNavigate();
	const { id } = useParams();
	const [confirmModal, setConfirmModal] = useState(false);
	const [loading, setLoading] = useState(true);
	const [isEditable, setIsEditable] = useState(false);
	const [formData, setFormData] = useState({});
	const [departmentOptions, setDepartmentOptions] = useState([]);
	const [privilegeOptions, setPrivilegeOptions] = useState([]);
	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	useEffect(() => {
		singleAdminData();
		setDepartmentData();
	}, []);

	//get department
	const setDepartmentData = async () => {
		try {
			const data = await getDepartments();
			if (data?.result) {
				// console.log(data.result);
				setDepartmentOptions(data.result);
			} else {
				setDepartmentOptions([]);
			}
		} catch (error) {
			toast.error("unable to fetch department data, please try again later");
		}
	};

	//get privileges
	const setPrivileges = async (id) => {
		try {
			const data = await getPrivileges(id);
			// console.log(data);
			if (data?.result) {
				// console.log(data.result);
				setPrivilegeOptions(data?.result?.roles);
			} else {
				setPrivilegeOptions([]);
			}
		} catch (error) {
			toast.error(
				"unable to fetch department privileges, please try again later"
			);
		}
	};

	//handle department selection
	const handleDepartment = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
		const selectedDepartment = e.target.value;

		//find object of selected department from array of departments
		const selectedDepartmentObject = departmentOptions.find(
			(item) => item.department === selectedDepartment
		);
		setPrivileges(selectedDepartmentObject?.objectId);
	};

	const singleAdminData = async () => {
		try {
			const data = await getSingleAdmin(id);
			if (data.result) {
				setFormData(data.result);
				// console.log(data.result);
				setLoading(false);
			} else {
				toast.error("error fetching admin data!");
				setLoading(false);
			}
		} catch (error) {
			console.error(error);
			toast.error("error fetching admin data!");
			setLoading(false);
		}
	};

	//delete User
	const deleteUser = async () => {
		setLoading(true);
		let data = await deleteAdmin(id);
		try {
			if (data.result) {
				setLoading(false);
				toast.success("user deleted successfully");
				navigate("/users");
			} else {
				setLoading(false);
				toast.error("Unable to delete user, please try again later");
			}
		} catch (error) {
			setLoading(false);
			toast.error("Unable to delete user, please try again later");
		}
	};

	const updateAdmin = async () => {
		setLoading(true);
		let data = await updateAdminDetails({ ...formData, id: formData.objectId });
		try {
			if (data.result) {
				setLoading(false);
				toast.success("user details updated successfully");
				navigate("/users");
			} else {
				setLoading(false);
				toast.error(data.error);
			}
		} catch (error) {
			setLoading(false);
			toast.error(
				"error occured while updating details, please try again later"
			);
		}
	};

	return (
		<AdminDashboardLayout>
			<DashboardWrapper>
				<IntroductionHeader nav={true} />
				<InformationsWrapper className='mt-20'>
					<p className='avatar'>
						<img src='/images/UserAvatar_img.svg' alt='user image' />
					</p>

					<FormAccordion className='mt-4' title='User information' open={true}>
						<div className='grid grid-cols-3 gap-5'>
							<Formgroup type='users'>
								<label>Last name</label>
								<InputField
									name='lastName'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.lastName}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>First name</label>
								<InputField
									name='firstName'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.firstName}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Email address</label>
								<InputField
									name='email'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.email}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Phone number</label>
								<InputField
									name='phone'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.phone}
									type={'tel'}
									maxLength={13}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Gender</label>
								<SelectField
									name='gender'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.gender}
									options={["male", "female"]}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Home address</label>
								<InputField
									name='homeAddress'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.homeAddress}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Department</label>
								<SelectField
									name='role'
									handleChange={handleDepartment}
									isEditable={isEditable}
									value={formData?.role}
									options={departmentOptions}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Privileges</label>
								<SelectField
									name='privileges'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.privileges}
									options={
										privilegeOptions.length > 0
											? privilegeOptions
											: [formData?.privileges]
									}
								/>
							</Formgroup>
						</div>

						<ButtonGroup>
							{isEditable ? (
								<Button
									onClick={updateAdmin}
									type='submit'
									color='#ffffff'
									backgroundcolor='#003A50'
								>
									<img src={saveIcon} />
									<p>Update</p>
								</Button>
							) : (
								<Button
									type='submit'
									color='#006770'
									border='true'
									backgroundcolor='#ffffff'
									onClick={() => setIsEditable(true)}
								>
									<p>Edit Details</p>
								</Button>
							)}

							<Button
								type='button'
								onClick={() => {
									setConfirmModal(true);
								}}
								backgroundcolor='#FFA463'
								color='#ffffff'
							>
								<AiOutlineDelete size={20} />
								<p>Delete user</p>
							</Button>
						</ButtonGroup>
					</FormAccordion>
				</InformationsWrapper>
				{loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
				{confirmModal && (
					<ConfirmModal
						confirmModal={confirmModal}
						setConfirmModal={setConfirmModal}
						content={{
							title: "Delete user",
							desc: "Are you sure you want to delete this user?",
							btnText: "Yes, Delete",
						}}
						handleDeleteAction={deleteUser}
					/>
				)}
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default SingleUser;
